// extracted by mini-css-extract-plugin
export default {"WelcomeMessage":"WelcomeMessage__aG-JH","heading":"heading__1Rjru","subheading":"subheading__8znav"};